import { Share2, MessageCircle, Facebook, Link2, Instagram } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { api, BACKEND } from "@/lib/api";

export const ShareMenu = ({ deal, className = "", testid = "share-button" }) => {
  const pageUrl = `${window.location.origin}/deals/${deal.slug}`;
  const ogUrl = `${BACKEND}/api/og/deals/${deal.slug}`;
  const text = `${deal.title} at ${deal.merchant_name} on SuperDeals.world`;
  const track = (channel) => api.post(`/deals/${deal.id}/share`, { channel }).catch(() => {});

  const actions = {
    whatsapp: () => window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${ogUrl}`)}`, "_blank"),
    facebook: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(ogUrl)}`, "_blank"),
    copy: async () => {
      await navigator.clipboard?.writeText(pageUrl);
      toast.success("Deal link copied");
    },
    native: async () => {
      if (!navigator.share) return actions.copy();
      try {
        await navigator.share({ title: deal.title, text, url: pageUrl });
      } catch {}
    },
  };
  const run = (c, fn) => (e) => {
    e.stopPropagation();
    track(c);
    fn();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
        <button data-testid={testid} aria-label="Share deal" className={`inline-flex items-center justify-center rounded-full bg-white/95 border border-slate-200 w-9 h-9 hover:bg-slate-50 active:scale-95 transition-transform ${className}`}>
          <Share2 className="w-4 h-4 text-slate-700" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem data-testid="share-whatsapp" onClick={run("whatsapp", actions.whatsapp)}><MessageCircle className="w-4 h-4 mr-2 text-emerald-600" />WhatsApp</DropdownMenuItem>
        <DropdownMenuItem data-testid="share-facebook" onClick={run("facebook", actions.facebook)}><Facebook className="w-4 h-4 mr-2 text-blue-600" />Facebook</DropdownMenuItem>
        <DropdownMenuItem data-testid="share-instagram" onClick={run("instagram", actions.native)}><Instagram className="w-4 h-4 mr-2 text-pink-600" />Instagram / More apps</DropdownMenuItem>
        <DropdownMenuItem data-testid="share-copy" onClick={run("copy", actions.copy)}><Link2 className="w-4 h-4 mr-2" />Copy link</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
